<template>
    <v-card>
        <v-container class="pa-0" fluid>
            <v-row no-gutters>
                <v-col cols="6">
                    <strong>Extraction Date:</strong> {{ formData.RecordedAt | formatDate }}
                </v-col>
                <v-col cols="6">
                </v-col>
                <v-col cols="6">
                    <strong>Primary Extractor:</strong> {{formData.PrimaryExtractorEmail}}
                </v-col>
                <v-col cols="6">
                    <strong>Assistant Extractor:</strong> {{formData.AssistantEmail}}
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="6">
                    <v-container class="pa-0" fluid>
                        <v-row no-gutters>
                            <v-col cols="12">
                                <span class="title">Specimen Information</span>
                            </v-col>
                            <v-col cols="12">
                                <strong>Skip:</strong>
                                <FormSelector :disabled="disabled" label="MED" v-model="formData.SpecimenSkipMed"></FormSelector>
                                <FormSelector :disabled="disabled" label="Poor Feed" v-model="formData.SpecimenSkipPoorFeed"></FormSelector>
                                <FormSelector :disabled="disabled" label="Behavior" v-model="formData.SpecimenSkipBehavior"></FormSelector>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field  :disabled="disabled"
                                    v-model="formData.SpecimenCoolTimeTemp"
                                    label="Cool Time / Temp (ᵒF)">
                                </v-text-field >
                            </v-col>
                            <v-col cols="12">
                                <FormSelector :disabled="disabled" label="TSC" v-model="formData.SpecimenTSC"></FormSelector>
                                <FormSelector :disabled="disabled" label="BSC" v-model="formData.SpecimenBSC"></FormSelector>
                            </v-col>
                            <v-col cols="12">
                                <FormSelector :disabled="disabled" label="2CVB" v-model="formData.Specimen2CVB"></FormSelector>
                                <FormSelector :disabled="disabled" label="Banked In" v-model="formData.SpecimenBankedIn"></FormSelector>
                                <FormSelector :disabled="disabled" label="Ran In" v-model="formData.SpecimenRanIn"></FormSelector>
                                <FormSelector :disabled="disabled" label="Assist" v-model="formData.SpecimenAssist"></FormSelector>
                                <FormSelector :disabled="disabled" label="Backed Out" v-model="formData.SpecimenBackedOut"></FormSelector>
                            </v-col>
                            <v-col cols="12">
                                <strong>Floor Behaviour:</strong>
                            </v-col>
                            <v-col cols="12">
                                <FormSelector :disabled="disabled" label="Striking" v-model="formData.SpecimenStriking"></FormSelector>
                                <FormSelector :disabled="disabled" label="Lunging" v-model="formData.SpecimenLunging"></FormSelector>
                                <FormSelector :disabled="disabled" label="Wanders" v-model="formData.SpecimenWanders"></FormSelector>
                                <FormSelector :disabled="disabled" label="Spaz" v-model="formData.SpecimenSpaz"></FormSelector>
                                <FormSelector :disabled="disabled" label="AGG" v-model="formData.SpecimenAGG"></FormSelector>
                                <FormSelector :disabled="disabled" label="DIFF" v-model="formData.SpecimenDIFF"></FormSelector>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-col>
                <v-col cols="6">
                    <v-container class="pa-0" fluid>
                        <v-row no-gutters>
                            <v-col cols="12">
                                <span class="title">Extraction Setup</span>
                            </v-col>
                            <v-col cols="12">
                                <strong>PF:</strong><FormSelector :disabled="disabled" label="1" v-model="formData.ExtractionPF1"></FormSelector>
                                <FormSelector :disabled="disabled" label="2" v-model="formData.ExtractionPF2"></FormSelector>
                                <FormSelector :disabled="disabled" label="3" v-model="formData.ExtractionPF3"></FormSelector>
                                <FormSelector :disabled="disabled" label="4" v-model="formData.ExtractionPF4"></FormSelector>
                                <FormSelector :disabled="disabled" label="5" v-model="formData.ExtractionPF5"></FormSelector>
                                <FormSelector :disabled="disabled" label="Pre Cut" v-model="formData.ExtractionPFPreCut"></FormSelector>
                            </v-col>
                            <v-col cols="12">
                                <strong>Tape:</strong><FormSelector :disabled="disabled" label="1" v-model="formData.ExtractionTape1"></FormSelector>
                                <FormSelector :disabled="disabled" label="2" v-model="formData.ExtractionTape2"></FormSelector>
                                <FormSelector :disabled="disabled" label="3" v-model="formData.ExtractionTape3"></FormSelector>
                                <FormSelector :disabled="disabled" label="4" v-model="formData.ExtractionTape4"></FormSelector>
                                <FormSelector :disabled="disabled" label="5" v-model="formData.ExtractionTape5"></FormSelector>
                            </v-col>
                            <v-col cols="12">
                                <strong>APP Sets:</strong><FormSelector :disabled="disabled" label="1" v-model="formData.ExtractionAPPSet1"></FormSelector>
                                <FormSelector :disabled="disabled" label="2" v-model="formData.ExtractionAPPSet2"></FormSelector>
                                <FormSelector :disabled="disabled" label="3" v-model="formData.ExtractionAPPSet3"></FormSelector>
                                <FormSelector :disabled="disabled" label="4" v-model="formData.ExtractionAPPSet4"></FormSelector>
                            </v-col>
                            <v-col cols="12">
                                <FormSelector :disabled="disabled" label="HT" v-model="formData.ExtractionHT"></FormSelector>
                                <FormSelector :disabled="disabled" label="SD" v-model="formData.ExtractionSD"></FormSelector>
                                <FormSelector :disabled="disabled" label="RBS" v-model="formData.ExtractionRBS"></FormSelector>
                                <FormSelector :disabled="disabled" label="BON" v-model="formData.ExtractionBON"></FormSelector>
                            </v-col>
                            <v-col cols="12">
                                <strong>Funnel:</strong><FormSelector :disabled="disabled" label="XS" v-model="formData.ExtractionFunnelXS"></FormSelector>
                                <FormSelector :disabled="disabled" label="S" v-model="formData.ExtractionFunnelS"></FormSelector>
                                <FormSelector :disabled="disabled" label="M" v-model="formData.ExtractionFunnelM"></FormSelector>
                                <FormSelector :disabled="disabled" label="L" v-model="formData.ExtractionFunnelL"></FormSelector>
                                <FormSelector :disabled="disabled" label="XL" v-model="formData.ExtractionFunnelXL"></FormSelector>
                                <FormSelector :disabled="disabled" label="J" v-model="formData.ExtractionFunnelJ"></FormSelector>
                            </v-col>
                            <v-col cols="12">
                                <FormSelector :disabled="disabled" label="Glass" v-model="formData.ExtractionGlass"></FormSelector>
                                <FormSelector :disabled="disabled" label="Plexi" v-model="formData.ExtractionPlexi"></FormSelector>
                            </v-col>
                            <v-col cols="12">
                                <strong>Tube:</strong><FormSelector :disabled="disabled" label="XS" v-model="formData.ExtractionTubeXS"></FormSelector>
                                <FormSelector :disabled="disabled" label="S" v-model="formData.ExtractionTubeS"></FormSelector>
                                <FormSelector :disabled="disabled" label="M" v-model="formData.ExtractionTubeM"></FormSelector>
                                <FormSelector :disabled="disabled" label="L" v-model="formData.ExtractionTubeL"></FormSelector>
                                <FormSelector :disabled="disabled" label="XL" v-model="formData.ExtractionTubeXL"></FormSelector>
                                <FormSelector :disabled="disabled" label="J" v-model="formData.ExtractionTubeJ"></FormSelector>
                            </v-col>
                            <v-col cols="12">
                                <FormSelector :disabled="disabled" label="Soft" v-model="formData.ExtractionSoft"></FormSelector>
                                <FormSelector :disabled="disabled" label="Hard" v-model="formData.ExtractionHard"></FormSelector>
                                <FormSelector :disabled="disabled" label="Long" v-model="formData.ExtractionLong"></FormSelector>
                                <FormSelector :disabled="disabled" label="Black" v-model="formData.ExtractionBlack"></FormSelector>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-col>
                <v-col cols="6">
                    <v-container class="pa-0" fluid>
                        <v-row no-gutters>
                            <v-col cols="12">
                                <span class="title">Pin Information</span>
                            </v-col>
                            <v-col cols="8">
                                <strong>LOTP:</strong><FormSelector :disabled="disabled" label="TLS" v-model="formData.PinLOTPTLS"></FormSelector>
                                <FormSelector :disabled="disabled" label="TNS" v-model="formData.PinLOTPTNS"></FormSelector>
                                <FormSelector :disabled="disabled" label="TCAIP" v-model="formData.PinLOTPTCAIP"></FormSelector>
                            </v-col>
                            <v-col cols="4">
                                <FormSelector :disabled="disabled" label="NTOS" v-model="formData.PinNTOS"></FormSelector>
                            </v-col>
                            <v-col cols="4">
                                <strong>TP:</strong><FormSelector :disabled="disabled" label="F" v-model="formData.PinTPF"></FormSelector>
                                <FormSelector :disabled="disabled" label="C" v-model="formData.PinTPC"></FormSelector>
                            </v-col>
                            <v-col cols="4">
                                <strong>JH:</strong><FormSelector :disabled="disabled" label="L" v-model="formData.PinJHL"></FormSelector>
                                <FormSelector :disabled="disabled" label="R" v-model="formData.PinJHR"></FormSelector>
                            </v-col>
                            <v-col cols="4">
                                <FormSelector :disabled="disabled" label="Squirm" v-model="formData.PinSquirm"></FormSelector>
                            </v-col>
                            <v-col cols="8">
                                <FormSelector :disabled="disabled" label="1TPB" v-model="formData.Pin1TPB"></FormSelector>
                                <FormSelector :disabled="disabled" label="2TPB" v-model="formData.Pin2TPB"></FormSelector>
                                <FormSelector :disabled="disabled" label="BP" v-model="formData.PinBP"></FormSelector>
                                <FormSelector :disabled="disabled" label="AP" v-model="formData.PinAP"></FormSelector>
                            </v-col>
                            <v-col cols="4">
                                <FormSelector :disabled="disabled" label="Short Burst" v-model="formData.PinShortBurst"></FormSelector>
                            </v-col>
                            <v-col cols="8">
                                <FormSelector :disabled="disabled" label="1HRT" v-model="formData.Pin1HRT"></FormSelector>
                                <FormSelector :disabled="disabled" label="2HRT" v-model="formData.Pin2HRT"></FormSelector>
                                <FormSelector :disabled="disabled" label="TNU" v-model="formData.PinTNU"></FormSelector>
                            </v-col>
                            <v-col cols="4">
                                <FormSelector :disabled="disabled" label="Extreme" v-model="formData.PinExtreme"></FormSelector>
                            </v-col>
                            <v-col cols="8">
                                <FormSelector :disabled="disabled" label="T" v-model="formData.PinT"></FormSelector>
                                <FormSelector :disabled="disabled" label="TDD" v-model="formData.PinTDD"></FormSelector>
                                <FormSelector :disabled="disabled" label="TCP" v-model="formData.PinTCP"></FormSelector>
                                <FormSelector :disabled="disabled" label="LE" v-model="formData.PinLE"></FormSelector>
                            </v-col>
                            <v-col cols="4">
                                <FormSelector :disabled="disabled" label="Lock Finger" v-model="formData.PinLockFinger"></FormSelector>
                            </v-col>
                            <v-col cols="4">
                                <FormSelector :disabled="disabled" label="LP" v-model="formData.PinLP"></FormSelector>
                                <FormSelector :disabled="disabled" label="MP" v-model="formData.PinMP"></FormSelector>
                                <FormSelector :disabled="disabled" label="HP" v-model="formData.PinHP"></FormSelector>
                            </v-col>
                            <v-col cols="4">
                                <FormSelector :disabled="disabled" label="LB" v-model="formData.PinLB"></FormSelector>
                                <FormSelector :disabled="disabled" label="MB" v-model="formData.PinMB"></FormSelector>
                                <FormSelector :disabled="disabled" label="HB" v-model="formData.PinHB"></FormSelector>
                            </v-col>
                            <v-col cols="4">
                                <FormSelector :disabled="disabled" label="Drop Jaws" v-model="formData.PinDropJaws"></FormSelector>
                            </v-col>
                            <v-col cols="4">
                                <strong>SW:</strong><FormSelector :disabled="disabled" label="L" v-model="formData.PinSWL"></FormSelector>
                                <FormSelector :disabled="disabled" label="R" v-model="formData.PinSWR"></FormSelector>
                            </v-col>
                            <v-col cols="4">
                                <strong>Push:</strong><FormSelector :disabled="disabled" label="F" v-model="formData.PinPushF"></FormSelector>
                                <FormSelector :disabled="disabled" label="B" v-model="formData.PinPushB"></FormSelector>
                            </v-col>
                            <v-col cols="4">
                                <FormSelector :disabled="disabled" label="Countered" v-model="formData.PinCountered"></FormSelector>
                            </v-col>
                            <v-col cols="8">
                                <strong>Roll:</strong><FormSelector :disabled="disabled" label="L" v-model="formData.PinRollL"></FormSelector>
                                <FormSelector :disabled="disabled" label="M" v-model="formData.PinRollM"></FormSelector>
                                <FormSelector :disabled="disabled" label="U" v-model="formData.PinRollU"></FormSelector>
                                <FormSelector :disabled="disabled" label="DR" v-model="formData.PinRollDR"></FormSelector>
                                <FormSelector :disabled="disabled" label="CKS" v-model="formData.PinRollCKS"></FormSelector>
                            </v-col>
                            <v-col cols="4">
                                <FormSelector :disabled="disabled" label="Standard" v-model="formData.PinStandard"></FormSelector>
                            </v-col>
                            <v-col cols="8">
                                <FormSelector :disabled="disabled" label="WP" v-model="formData.PinWP"></FormSelector>
                                <FormSelector :disabled="disabled" label="SK" v-model="formData.PinSK"></FormSelector>
                                <FormSelector :disabled="disabled" label="CH" v-model="formData.PinCH"></FormSelector>
                                <FormSelector :disabled="disabled" label="SHO" v-model="formData.PinSHO"></FormSelector>
                                <FormSelector :disabled="disabled" label="AIH" v-model="formData.PinAIH"></FormSelector>
                            </v-col>
                            <v-col cols="4">
                                <strong>B3:</strong><FormSelector :disabled="disabled" label="LT" v-model="formData.PinB3LT"></FormSelector>
                                <FormSelector :disabled="disabled" label="OP" v-model="formData.PinB3OP"></FormSelector>
                            </v-col>
                            <v-col cols="8">
                                <FormSelector :disabled="disabled" label="FO" v-model="formData.PinFO"></FormSelector>
                                <FormSelector :disabled="disabled" label="FOM" v-model="formData.PinFOM"></FormSelector>
                                <strong>FM:</strong><FormSelector :disabled="disabled" label="L" v-model="formData.PinFML"></FormSelector>
                                <FormSelector :disabled="disabled" label="R" v-model="formData.PinFMR"></FormSelector>
                            </v-col>
                            <v-col cols="4">
                                <strong>Crossbar:</strong><FormSelector :disabled="disabled" label="LT" v-model="formData.PinCrossbarLT"></FormSelector>
                                <FormSelector :disabled="disabled" label="M" v-model="formData.PinCrossbarM"></FormSelector>
                            </v-col>
                            <v-col cols="4">
                                <strong>TOR:</strong><FormSelector :disabled="disabled" label="L" v-model="formData.PinTORL"></FormSelector>
                                <FormSelector :disabled="disabled" label="R" v-model="formData.PinTORR"></FormSelector>
                            </v-col>
                            <v-col cols="4">
                                <strong>PT:</strong><FormSelector :disabled="disabled" label="L" v-model="formData.PinPTL"></FormSelector>
                                <FormSelector :disabled="disabled" label="R" v-model="formData.PinPTR"></FormSelector>
                            </v-col>
                            <v-col cols="4">
                                <strong>Forearm:</strong><FormSelector :disabled="disabled" label="LT" v-model="formData.PinForearmLT"></FormSelector>
                                <FormSelector :disabled="disabled" label="M" v-model="formData.PinForearmM"></FormSelector>
                            </v-col>
                            <v-col cols="12">
                                <strong>Nose Down Behaviour:</strong><FormSelector :disabled="disabled" label="+" v-model="formData.PinNoseDownPlus"></FormSelector>
                                <FormSelector :disabled="disabled" label="-" v-model="formData.PinNoseDownMinus"></FormSelector>
                            </v-col>
                            <v-col cols="4">
                                <FormSelector :disabled="disabled" label="SPP" v-model="formData.PinSPP"></FormSelector>
                                <FormSelector :disabled="disabled" label="FXRP" v-model="formData.FXRP"></FormSelector>
                            </v-col>
                            <v-col cols="4">
                                <FormSelector :disabled="disabled" label="MWS" v-model="formData.PinMWS"></FormSelector>
                            </v-col>
                            <v-col cols="4">
                                <FormSelector :disabled="disabled" label="BSNT" v-model="formData.PinBSNT"></FormSelector>
                                <FormSelector :disabled="disabled" label="BST" v-model="formData.PinBST"></FormSelector>
                            </v-col>
                            <v-col cols="12">
                                <NumericEntry :disabled="disabled"
                                    v-model="formData.PinAnglePullAborted"
                                    label="Angle Pull Aborted">
                                </NumericEntry>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-col>
                <v-col cols="6">
                    <v-container class="pa-0" fluid>
                        <v-row no-gutters>
                            <v-col cols="12">
                                <span class="title">Funnel Information</span>
                            </v-col>
                            <v-col cols="4">
                                <FormSelector :disabled="disabled" label="LP" v-model="formData.FunnelLP"></FormSelector>
                                <FormSelector :disabled="disabled" label="MP" v-model="formData.FunnelMP"></FormSelector>
                                <FormSelector :disabled="disabled" label="HP" v-model="formData.FunnelHP"></FormSelector>
                            </v-col>
                            <v-col cols="4">
                                <FormSelector :disabled="disabled" label="LB" v-model="formData.FunnelLB"></FormSelector>
                                <FormSelector :disabled="disabled" label="MB" v-model="formData.FunnelMB"></FormSelector>
                                <FormSelector :disabled="disabled" label="HB" v-model="formData.FunnelHB"></FormSelector>
                            </v-col>
                            <v-col cols="4">
                                <FormSelector :disabled="disabled" label="Squirm" v-model="formData.FunnelSquirm"></FormSelector>
                            </v-col>
                            <v-col cols="4">
                                <strong>SW:</strong><FormSelector :disabled="disabled" label="L" v-model="formData.FunnelSWL"></FormSelector>
                                <FormSelector :disabled="disabled" label="R" v-model="formData.FunnelSWR"></FormSelector>
                            </v-col>
                            <v-col cols="4">
                                <strong>Push:</strong><FormSelector :disabled="disabled" label="F" v-model="formData.FunnelPushF"></FormSelector>
                                <FormSelector :disabled="disabled" label="B" v-model="formData.FunnelPushB"></FormSelector>
                            </v-col>
                            <v-col cols="4">
                                <FormSelector :disabled="disabled" label="Short Burst" v-model="formData.FunnelShortBurst"></FormSelector>
                            </v-col>
                            <v-col cols="8">
                                <strong>Roll:</strong><FormSelector :disabled="disabled" label="L" v-model="formData.FunnelRollL"></FormSelector>
                                <FormSelector :disabled="disabled" label="M" v-model="formData.FunnelRollM"></FormSelector>
                                <FormSelector :disabled="disabled" label="U" v-model="formData.FunnelRollU"></FormSelector>
                                <FormSelector :disabled="disabled" label="DR" v-model="formData.FunnelRollDR"></FormSelector>
                                <FormSelector :disabled="disabled" label="CKS" v-model="formData.FunnelRollCKS"></FormSelector>
                            </v-col>
                            <v-col cols="4">
                                <FormSelector :disabled="disabled" label="Extreme" v-model="formData.FunnelExtreme"></FormSelector>
                            </v-col>
                            <v-col cols="8">
                                <FormSelector :disabled="disabled" label="WP" v-model="formData.FunnelWP"></FormSelector>
                                <FormSelector :disabled="disabled" label="SK" v-model="formData.FunnelSK"></FormSelector>
                                <FormSelector :disabled="disabled" label="CH" v-model="formData.FunnelCH"></FormSelector>
                                <FormSelector :disabled="disabled" label="SHO" v-model="formData.FunnelSHO"></FormSelector>
                                <FormSelector :disabled="disabled" label="AIH" v-model="formData.FunnelAIH"></FormSelector>
                            </v-col>
                            <v-col cols="4">
                                <FormSelector :disabled="disabled" label="Lock Finger" v-model="formData.FunnelLockFinger"></FormSelector>
                            </v-col>
                            <v-col cols="4">
                                <strong>HMOWT:</strong><FormSelector :disabled="disabled" label="L" v-model="formData.FunnelHMOWTL"></FormSelector>
                                <FormSelector :disabled="disabled" label="R" v-model="formData.FunnelHMOWTR"></FormSelector>
                            </v-col>
                            <v-col cols="4">
                                <FormSelector :disabled="disabled" label="MWS" v-model="formData.FunnelMWS"></FormSelector>
                            </v-col>
                            <v-col cols="4">
                                <FormSelector :disabled="disabled" label="Drop Jaws" v-model="formData.FunnelDropJaws"></FormSelector>
                            </v-col>
                            <v-col cols="8">
                                <strong>HMOWA:</strong><FormSelector :disabled="disabled" label="Leave" v-model="formData.FunnelHMOWALeave"></FormSelector>
                                <FormSelector :disabled="disabled" label="Removed" v-model="formData.FunnelHMOWARemoved"></FormSelector>
                            </v-col>
                            <v-col cols="4">
                                <FormSelector :disabled="disabled" label="Countered" v-model="formData.FunnelCountered"></FormSelector>
                            </v-col>
                            <v-col cols="12">
                                <FormSelector :disabled="disabled" label="WFT" v-model="formData.FunnelWFT"></FormSelector>
                                <FormSelector :disabled="disabled" label="LOF" v-model="formData.FunnelLOF"></FormSelector>
                                <FormSelector :disabled="disabled" label="CM" v-model="formData.FunnelCM"></FormSelector>
                                <FormSelector :disabled="disabled" label="Coax" v-model="formData.FunnelCoax"></FormSelector>
                                <FormSelector :disabled="disabled" label="CFO" v-model="formData.FunnelCFO"></FormSelector>
                                <FormSelector :disabled="disabled" label="OMWA" v-model="formData.FunnelOMWA"></FormSelector>
                            </v-col>
                            <v-col cols="12">
                                <FormSelector :disabled="disabled" label="TBM" v-model="formData.FunnelTBM"></FormSelector>
                                <FormSelector :disabled="disabled" label="BOF" v-model="formData.FunnelBOF"></FormSelector>
                                <FormSelector :disabled="disabled" label="LKF" v-model="formData.FunnelLKF"></FormSelector>
                                <FormSelector :disabled="disabled" label="PTC" v-model="formData.FunnelPTC"></FormSelector>
                                <FormSelector :disabled="disabled" label="RWA" v-model="formData.FunnelRWA"></FormSelector>
                                <strong>DNRF:</strong><FormSelector :disabled="disabled" label="L" v-model="formData.FunnelDNRFL"></FormSelector>
                                <FormSelector :disabled="disabled" label="R" v-model="formData.FunnelDNRFR"></FormSelector>
                            </v-col>
                            <v-col cols="4">
                                <FormSelector :disabled="disabled" label="NB+" v-model="formData.FunnelNBPlus"></FormSelector>
                            </v-col>
                            <v-col cols="4">
                                <FormSelector :disabled="disabled" label="VH" v-model="formData.FunnelVH"></FormSelector>
                            </v-col>
                            <v-col cols="4">
                                <FormSelector :disabled="disabled" label="VH+" v-model="formData.FunnelVHPlus"></FormSelector>
                            </v-col>
                            <v-col cols="4">
                                <FormSelector :disabled="disabled" label="SQ" v-model="formData.FunnelSQ"></FormSelector>
                            </v-col>
                            <v-col cols="4">
                                <FormSelector :disabled="disabled" label="No Bite" v-model="formData.FunnelNoBite"></FormSelector>
                            </v-col>
                            <v-col cols="4">
                                <FormSelector :disabled="disabled" label="No Venom" v-model="formData.FunnelNoVenom"></FormSelector>
                            </v-col>
                            <v-col cols="4">
                                <NumericEntry :disabled="disabled"
                                    v-model="formData.FunnelBite"
                                    label="Bite">
                                </NumericEntry>
                            </v-col>
                            <v-col cols="4">
                                <NumericEntry :disabled="disabled"
                                    v-model="formData.FunnelBulldog"
                                    label="Bulldog">
                                </NumericEntry>
                            </v-col>
                            <v-col cols="4">
                                <NumericEntry :disabled="disabled"
                                    v-model="formData.FunnelChewing"
                                    label="Chewing">
                                </NumericEntry>
                            </v-col>
                            <v-col cols="4">
                                <NumericEntry :disabled="disabled"
                                    v-model="formData.FunnelClimbing"
                                    label="Climbing">
                                </NumericEntry>
                            </v-col>
                            <v-col cols="4">
                                <NumericEntry :disabled="disabled"
                                    v-model="formData.FunnelHolding"
                                    label="Holding">
                                </NumericEntry>
                            </v-col>
                            <v-col cols="4">
                                <NumericEntry :disabled="disabled"
                                    v-model="formData.FunnelPulse"
                                    label="Pulse">
                                </NumericEntry>
                            </v-col>
                            <v-col cols="4">
                                <NumericEntry :disabled="disabled"
                                    v-model="formData.FunnelStabbing"
                                    label="Stabbing">
                                </NumericEntry>
                            </v-col>
                            <v-col cols="4">
                                <NumericEntry :disabled="disabled"
                                    v-model="formData.Funnel180"
                                    label="180ᵒ">
                                </NumericEntry>
                            </v-col>
                            <v-col cols="4">
                                <NumericEntry :disabled="disabled"
                                    v-model="formData.FunnelBiteTime"
                                    label="Bite Time">
                                </NumericEntry>
                            </v-col>
                            <v-col cols="12">
                                <NumericEntry :disabled="disabled"
                                    v-model="formData.FunnelMXPercentOfVenomCollected"
                                    label="MX = % OF Venom Collected:">
                                </NumericEntry>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-col>
                <v-col cols="12">
                    <v-textarea :disabled="disabled" label="Comment" v-model="formData.Comment"></v-textarea>
                </v-col>
                <v-col cols="12">
                    <v-switch
                        v-model="formData.VenomCollected"
                        label="Venom Collected"
                        :disabled="disabled"
                    ></v-switch>
                </v-col>
                <v-col
                    cols="12"
                    v-show="!formData.VenomCollected"
                >
                    <v-textarea
                        counter="2000"
                        maxlength="2000"
                        v-model="formData.CollectionComment"
                        label="Non-collection Comment"
                        :disabled="disabled"
                    >
                    </v-textarea>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
import FormSelector from "@/components/common/FormSelector.vue"
import NumericEntry from "@/components/common/NumericEntry";
import moment from "moment";
import constants from "comunet-btg-utah-repository-shared/constants";

export default {
    components: {
        FormSelector,
        NumericEntry
    },
    props: {
        formData: {
            type: Object,
            default: () => {}
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    filters: {
        formatDate: function (value) {
            var date = moment(value);
            if (date.isValid) {
                return date.format(constants.DATE_FORMAT);
            } else {
                return value;
            }
        }
    }
}
</script>